export function generateRandomId() {
    return Math.floor(1000 + Math.random() * 9000).toString();
}

export function toStrictBoolean(val) {
    return val === true || val === 'true';
}